const mutations = {
    'SET_NOTES' (state, { notes }) {
      state.notes = notes;
    }
  }
  
  export default mutations